module.exports = new __parcel__URL__("empty.bc8457e3.svg").toString();